export const UPDATE_DATA = 'app/EditSessionPage/VisualAnalogueScale/UPDATE';
export const UPDATE_VARIABLE =
  'app/EditSessionPage/VisualAnalogueScale/UPDATE_VARIABLE';
